import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
import { closeModal } from '../../redux/reducers/modal.js';
// components
import Icon from '../../components/Icon/Icon';
// modal components
import Billing from '../Billing/Billing';
import ChangePassword from '../../containers/UserProfile/components/ChangePasswordForm';
import UpdateSkill from '../Skills/components/UpdateSkill';
import DeleteSkill from '../Skills/components/DeleteSkill';
import DeleteAccount from '../UserProfile/components/DeleteAccountModal';
import DeleteUserSupportModal from '../UserProfile/components/DeleteUserSupportModal';
import AddNewNote from '../Journal/components/AddNewNote';
import DeleteNote from '../Journal/components/DeleteNote';
import EditNote from '../Journal/components/EditNote';
import FullNoteBlock from '../Journal/components/NoteViewer';
import Lecture from '../../components/Lecture/Lecture';
import ResetClock from '../RecoveryPlan/components/ResetClock';
import CheckInInvitation from '../Module/components/CheckInInvitation';
// styles
import styles from './ModalContainer.mod.css';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

const MODAL_COMPONENTS = {
  BILLING: Billing,
  CHANGE_PASSWORD: ChangePassword,
  UPDATE_SKILL: UpdateSkill,
  DELETE_SKILL: DeleteSkill,
  DELETE_NOTE: DeleteNote,
  EDIT_NOTE: EditNote,
  FULL_NOTE_BLOCK: FullNoteBlock,
  DELETE_ACCOUNT: DeleteAccount,
  DELETE_USER_SUPPORT: DeleteUserSupportModal,
  ADD_NEW_NOTE: AddNewNote,
  RESET_CLOCK: ResetClock,
  CHECK_IN: CheckInInvitation,
  LECTURE: Lecture
};

class ModalContainer extends Component {
  componentWillReceiveProps({ modalType }) {
    document.body.style.overflow = modalType ? 'hidden' : 'auto';
  }

  listenKeyboard = event => {
    if (this.props.modalType)
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.props.closeModal();
      }
  };

  listenPopstate = () => {
    if (this.props.modalType) {
      this.props.closeModal();
    }
  };

  componentDidMount() {
    window.addEventListener('keydown', this.listenKeyboard, true);
    window.addEventListener('popstate', this.listenPopstate, true);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.listenKeyboard, true);
    window.addEventListener('popstate', this.listenPopstate, true);
  }

  onModalClick = e => {
    e.stopPropagation();
  };

  render() {
    const { modalType, closeModal, modalData } = this.props;
    const Component = MODAL_COMPONENTS[modalType];

    return modalType ? (
      <div className={cx('container', 'fadeIn')} onClick={closeModal}>
        <div className={cx('wrapper')} onClick={this.onModalClick}>
          <Icon
            type="close"
            className={cx('closeButton')}
            onClick={closeModal}
          />
          <div className={cx('scrollable')}>
            <Component closeModal={closeModal} isModal modalData={modalData} />
          </div>
        </div>
      </div>
    ) : null;
  }
}

ModalContainer.propTypes = {
  modalType: T.string,
  modalData: T.object
};

export default connect(
  state => ({
    modalType: state.modal.modalType,
    modalData: state.modal.modalData
  }),
  { closeModal }
)(ModalContainer);



// WEBPACK FOOTER //
// ./src/containers/ModalContainer/ModalContainer.jsx